const apiConfig = {

 
  api_url: "https://appointmentapi.labofchoice.com/public/index.php/",
  slimapi_url: "https://appointmentapi.labofchoice.com/public/index.php/",
  //GNS_logoURL: "https://appointmentapi.labofchoice.com//public/GensysLogo/",

}

export default apiConfig
